import Vue from 'vue-for-shop';
// $ = jQuery = require('jquery');
import VueToastr from "vue-toastr"
import './cookie';
import VueInternationalization from 'vue-i18n'
import Locale from './vue-i18n-locales.generated'
import number_format from '@/Utils/number_format';

Vue.use(VueToastr,{
    defaultTimeout: 2000,
    defaultProgressBar: false,
    defaultProgressBarValue: 0,
    defaultType: "error",
    defaultPosition: "toast-top-full-width",
    defaultCloseOnHover: false,
    closeButton: true,
    //preventDuplicates: true,
    preventOpenDuplicates: true,
    defaultClassNames: ["animated", "zoomInUp"]
});
Vue.use(VueInternationalization);

const lang = document.documentElement.lang.substr(0, 2);
const i18n = new VueInternationalization({
    locale: lang,
    messages: Locale,
    fallbackLocale: 'en',
});

let $pageProps = {};


Vue.mixin({
    methods: {
        currentLocale: () => {
            return document.documentElement.lang.substr(0, 2);
        },
        route: (...args) => {
            if (args[0] === 'current') {
                args.shift();
                return window.route(window.route().current(), ...args).url();
            }

            return window.route(...args).url();
        },
        csrf: () => document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        isUrl(...urls) {
            if (urls[0] === '') {
                return location.pathname.substr(1) === ''
            }

            return !!urls.filter(url => url.endsWith(location.pathname.substr(0))).length;
        },
        isRoute(route, params = {}, exact = false) {

            const routeUrl = params ? this.route(route, params) : this.route(route);
            if (this.isUrl(routeUrl)) {
                return true;
            }
            const routePath = /https?:\/\/[^\/]+(.*)/.exec(routeUrl)[1];

            return exact ? route === routePath : location.pathname.startsWith(routePath);
        }
    }
});


Vue.filter('money', (value) => {
    return number_format(parseFloat(value), 2) + ' ' + $pageProps.currency.symbol;
});

Vue.filter('numberFormat', (value) => {
    return number_format(parseFloat(value), 2);
});


const files = require.context('./Shop', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const shopApp = new Vue({
    i18n,
    components: { },
    mounted() {
        this.$toastr.defaultPosition = 'toast-top-center';
    },
    methods:{
    }
}).$mount('#shop-app');